import script from "./repair-type-tip-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./repair-type-tip-dialog.vue?vue&type=script&lang=ts&setup=true"

import "./repair-type-tip-dialog.vue?vue&type=style&index=0&id=4eaa4ac5&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eaa4ac5"]])

export default __exports__